var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestactualidadEmojiFrownFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0,
    d: "M19,38A19,19,0,1,0,0,19,19,19,0,0,0,19,38ZM16.625,15.438C16.625,17.4,15.561,19,14.25,19s-2.375-1.6-2.375-3.562,1.064-3.562,2.375-3.562S16.625,13.471,16.625,15.438ZM10.177,29.528a1.187,1.187,0,0,1-.435-1.622,10.691,10.691,0,0,1,18.517,0A1.187,1.187,0,1,1,26.2,29.094a8.316,8.316,0,0,0-14.4,0,1.187,1.187,0,0,1-1.622.435ZM23.75,19c-1.311,0-2.375-1.6-2.375-3.562s1.064-3.562,2.375-3.562,2.375,1.6,2.375,3.563S25.061,19,23.75,19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestactualidadEmojiFrownFill);
export default __webpack_public_path__ + "static/media/testactualidad-emoji-frown-fill.d02b5348670dc4180a34ba156cb4f262.svg";
export { ForwardRef as ReactComponent };